'use client';

import { signInWithGoogleForLinking } from '@repo/auth';
import { Button, toast } from '@repo/ui';
import { Loader2 } from 'lucide-react';
import * as React from 'react';

import { GoogleIcon } from '../login/google-icon';

export function GoogleLinkButton({ callbackURL }: { callbackURL: string }): React.ReactNode {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleClick = (): void => {
    setIsLoading(true);
    signInWithGoogleForLinking(callbackURL).catch(() => {
      toast.error('Failed to redirect to Google');
      setIsLoading(false);
    });
  };

  return (
    <Button
      variant="outline"
      size="lg"
      className="w-full gap-2"
      onClick={handleClick}
      disabled={isLoading}
    >
      {isLoading ? <Loader2 className="size-4 animate-spin" /> : <GoogleIcon className="size-4" />}
      Continue with Google
    </Button>
  );
}
